var _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 18,
    viewBox: "0 0 118 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.267 6.69566L11.5478 5.48859L8.63281 0.422607V14.4603L13.9689 16.8455L13.3495 11.0334L17.267 6.69566Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71912 5.48859L0 6.69566L3.91747 11.0334L3.29809 16.8455L8.63415 14.4603V0.422607L5.71912 5.48859Z",
    fill: "#FFDA44"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4506 6.69566L36.7314 5.48859L33.8164 0.422607V14.4603L39.1525 16.8455L38.5331 11.0334L42.4506 6.69566Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9027 5.48859L25.1836 6.69566L29.1011 11.0334L28.4817 16.8455L33.8177 14.4603V0.422607L30.9027 5.48859Z",
    fill: "#FFDA44"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6342 6.69566L61.915 5.48859L59 0.422607V14.4603L64.3361 16.8455L63.7167 11.0334L67.6342 6.69566Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0863 5.48859L50.3672 6.69566L54.2847 11.0334L53.6653 16.8455L59.0013 14.4603V0.422607L56.0863 5.48859Z",
    fill: "#FFDA44"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8138 6.69566L87.0947 5.48859L84.1797 0.422607V14.4603L89.5157 16.8455L88.8964 11.0334L92.8138 6.69566Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.266 5.48859L75.5469 6.69566L79.4643 11.0334L78.845 16.8455L84.181 14.4603V0.422607L81.266 5.48859Z",
    fill: "#FFDA44"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.997 6.69566L112.278 5.48859L109.363 0.422607V14.4603L114.699 16.8455L114.08 11.0334L117.997 6.69566Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45 5.48859L100.73 6.69566L104.648 11.0334L104.029 16.8455L109.365 14.4603V0.422607L106.45 5.48859Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2683,
    height: 17.2683,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.1836,
    width: 17.2683,
    height: 17.2683,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.3672,
    width: 17.2683,
    height: 17.2683,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.5469,
    width: 17.2683,
    height: 17.2683,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.73,
    width: 17.2683,
    height: 17.2683,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.b46ce4d57139b496a6d0346a0caceb72.svg";
export { ForwardRef as ReactComponent };